import HistoryCompany from './HistoryCompany';

export default HistoryCompany;